var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "w-card",
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("desktop-app-connection"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("desktop-app-url") },
                        model: {
                          value: _vm.url,
                          callback: function ($$v) {
                            _vm.url = $$v
                          },
                          expression: "url",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }